import { render, staticRenderFns } from "./TheMamografia.vue?vue&type=template&id=3f71033e&scoped=true&"
import script from "./TheMamografia.vue?vue&type=script&lang=js&"
export * from "./TheMamografia.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./TheMamografia.vue?vue&type=style&index=1&id=3f71033e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71033e",
  null
  
)

export default component.exports